<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="mobile-max-modal"
      dialog-width="40rem"
      dialog-max-height="40rem"
    >
      <template #header>
        {{ ls({ ja: 'インポート', en: 'Import' }) }}
      </template>
      <div class="jps-modal-content">
        <BaseSlide :index="mode">
          <template #select="">
            <p class="jps-modal-explanation">
              {{
                ls({
                  ja: 'どこからインポートしますか？',
                  en: 'Where do you want to import from?',
                })
              }}
            </p>
            <table class="jps-table">
              <tbody>
                <tr>
                  <td>
                    <button class="jps-button jps-fullwidth" @click="selectCs">
                      {{ ls({ ja: 'テーマ別検索', en: 'Designed Search' }) }}
                    </button>
                  </td>
                  <td class="is-size-7">
                    {{
                      lss(
                        '公開されているテーマ別検索から選んでインポートできます',
                        'Import from published designed search',
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      class="jps-button jps-fullwidth"
                      @click="mode = 'json'"
                    >
                      {{ ls({ ja: 'JSONファイル', en: 'JSON File' }) }}
                    </button>
                  </td>
                  <td class="is-size-7">
                    {{
                      lss(
                        'テーマ別検索をExportしたJSONファイルからインポートできます',
                        'Import from exported JSON file',
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
          <template #gallery="">
            <p class="jps-modal-explanation">{{}}</p>
          </template>
          <template #json="">
            <BaseUpload
              v-model="file"
              accept="application/json"
              :message="{
                ja: 'JSONファイルを選んで下さい',
                en: 'Select JSON file',
              }"
            />
            <button
              v-if="file && file.length > 0"
              class="jps-round-button jps-blue jps-fullwidth"
              @click="selectJSON"
            >
              決定
            </button>
          </template>
        </BaseSlide>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.close) }}</button>
      </template>
    </UiModalDialog>
    <CsSelectorModal
      ref="csSelectorModal"
      :multiple="false"
      :selected="[]"
      :allow-gallery="false"
      :allow-all-types="false"
    />
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal, CsSelectorModal } from '#components'

const { ls, lss } = useI18n()

interface Props {
}
const props = withDefaults(defineProps<Props>(),{
})

const modal = ref<InstanceType<typeof BaseModal>>()
const mode: Ref<'select' | 'mysearch' | 'gallery' | 'json'> = ref('select')
const file: Ref<File[]> = ref([])
const openAwait = async () => {
  mode.value = 'select'
  file.value = []
  return await modal.value.openAwait<CustomSearchDefinition>()
}
defineExpose({ openAwait })

const csSelectorModal = ref<InstanceType<typeof CsSelectorModal>>()
const selectCs = async () => {
  try {
    const cs = await csSelectorModal.value.openAwait()
    modal.value.resolve(cs)
  } catch (cancel) {
    modal.value.reject()
  }
}

const selectJSON = () => {
  if (file.value && file.value.length > 0) {
    const fileReader = new FileReader()
    fileReader.onload = () => {
      const cs: CustomSearchDefinition = JSON.parse(fileReader.result as string)
      modal.value.resolve(cs)
    }
    fileReader.readAsText(file.value[0])
  }
}
</script>
